import { requestApi2 } from "@utils/http"
import { DbDevice, DeviceSignalRebootArgs, endpoints } from "api"
import { useEffect, useState } from "react"
import Button from "./Button"

export default function () {
	const [devices, setDevices] = useState<DbDevice[] | undefined>()

	const [deviceId, setDeviceId] = useState<number | undefined>()
	const [selectedDevice, setSelectedDevice] = useState<DbDevice | undefined>()
	const [tokenText, setTokenText] = useState<string>("")

	async function loadListOfDevices() {
		const res = await requestApi2(endpoints.getAllDevices)
		if (res === null) {
			return
		}
		setDevices(res)
	}

	useEffect(() => {
		if (devices == undefined) {
			loadListOfDevices()
		}
	}, [])

	useEffect(() => {
		setSelectedDevice(undefined)
		if (devices !== undefined) {
			for (const devicee of devices) {
				if (devicee.id == deviceId) {
					setSelectedDevice(devicee)
					break
				}
			}
		}
	}, [deviceId])

	async function rebootDevice() {
		if (selectedDevice !== undefined) {
			if (confirm("Are you sure you want to reboot device?") == true) {
				const argss: DeviceSignalRebootArgs = {
					deviceId: selectedDevice.id,
				}
				console.log(argss)
				try {
					await requestApi2(endpoints.deviceSignalReboot, argss)
				} catch (e) {
					alert(e)
				}
			}
		}
	}

	return (
		<>
			Select device to reboot:
			{devices == undefined ? (
				<p>Loading...</p>
			) : (
				<>
					<br></br>
					<label htmlFor="device-selector">Device name:</label>
					<br></br>
					<select
						id="device-selector"
						onChange={(evt) => setDeviceId(parseFloat(evt.target.value))}
						defaultValue={""}
					>
						<option disabled value="">
							{" "}
							-- select an option --{" "}
						</option>
						{devices.map((device, index) => {
							return (
								<option key={index} value={device.id}>
									{device.name + " @ " + device.plantName}
								</option>
							)
						})}
					</select>
				</>
			)}
			{selectedDevice !== undefined ? (
				<>
					<br></br> <Button label="Reboot device" onClick={() => rebootDevice()} />
				</>
			) : (
				<></>
			)}
		</>
	)
}
